import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/frontend/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/frontend/layouts/empty.vue").then(m => m.default || m)),
  "full-height": defineAsyncComponent(() => import("/frontend/layouts/full-height.vue").then(m => m.default || m))
}